import { useNavigate } from "react-router";
import CompanyAffiliatesLinksTable from "../../components/affiliates/CompanyAffiliatesLinksTable";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";


export default function CompanyAffiliatesLinks() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/?tab=myaffiliates`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Links"
                description="Meus links de afiliado"
            />
            <PageBreadcrumb
                pageTitle="Links de Afiliado"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <CompanyAffiliatesLinksTable />
                </div>
            </div>
        </>
    );
}